import { FASTElement } from "@microsoft/fast-element";
/**
 * CardPreview
 * @summary A CardPreview custom HTML Element that provides a preview container for card content, with an optional badge slot.
 *
 * @example
 * ```html
 * <fabric-card-preview>
 *   <div>Card content goes here</div>
 *   <span slot="badge">New</span>
 * </fabric-card-preview>
 * ```
 *
 * @slot - The default slot for the card preview content.
 * @slot badge - The slot for the badge content.
 *
 * @extends FASTElement
 * @tagname fabric-card-preview
 * @public
 */
export class CardPreview extends FASTElement {
}
//# sourceMappingURL=card-preview.js.map